import { DataType, IValidationError } from 'flux-definition';
import { AbstractDataItem } from './data-item-abstract';

/**
 * Data item class for the NUMBER_SLIDER data type. Data items in shape models with the NUMBER_SLIDER
 * data type will be deserialized into instances of this class by the `DataItemFactory`.
 */
export class NumberSliderDataItem extends AbstractDataItem<DataType.NUMBER_SLIDER> {
    /**
     * Checks whether the given value is valid (returns the error if any)
     */
    public validate( value: typeof NumberSliderDataItem.prototype.value ): IValidationError {
        if ( value === undefined ) {
            return null;
        }
        if ( typeof value === 'number' && !Number.isNaN( value )) {
            // TODO: consider min, max, step and other type parameters
            return null;
        }
        return { message: `"${value}" is not a valid number` };
    }
}
